import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-subtipos',
  templateUrl: '../../pages/curso/curso.component.html',
  styleUrls: ['../../pages/curso/curso.component.css']
})
export class CursoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
